var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthLayout',{attrs:{"is-full-height":_vm.isFullHeight}},[_c('SignUpForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }